import { Tooltip } from '@mui/material';
import { Attachment } from 'components/ImageViewer/ViewAttachmentsModal';
import React from 'react';
import { SPECIAL_INSTRUCTIONS_ATTACHMENT_FIELD_NAME } from 'components/Modals/QCPassFailModal/constants';

export const SpecialInstructionTooltip = ({ children, specialInstruction }) => {
  const isAttachedFileField =
    specialInstruction.field === SPECIAL_INSTRUCTIONS_ATTACHMENT_FIELD_NAME;

  return (
    <Tooltip
      title={
        isAttachedFileField ? (
          <Attachment file={specialInstruction.text} />
        ) : (
          specialInstruction.text
        )
      }
      placement="right"
    >
      {children}
    </Tooltip>
  );
};
